import axios from "axios";
import { refreshTokenSocial } from "services/user/user-login-social.service";
import { getToken, refreshSession, setStorage } from "services/user/user.session.service";
import { addRequest, closeRequest } from "services/util/loader.service";
const axiosApiInstance = axios.create();
let sessionRefreshedCounter = 0;




export default function () {
    axios.interceptors.request.use((config) => {
        const originalRequest: any = config;
        !originalRequest['removeLoading'] && addRequest();
        return originalRequest;
    })
    axios.interceptors.response.use((data) => {
        sessionRefreshedCounter = 0;
        closeRequest();
        return data;
    }, async (error) => {
        const originalRequest = error?.config;
        const status = error?.response?.status;
        const messageError = (error?.response?.data?.errors?.[0]?.message) ? error.response.data.errors[0].message : "";
        
        if (status === 401 && (messageError === "Expired Token" || messageError==="Invalid Token") && !originalRequest._retry && sessionRefreshedCounter < 5) {
            originalRequest._retry = true;
            let auth_information: any;
            try {
                sessionRefreshedCounter++;
                if(Boolean(localStorage.getItem('amplify-redirected-from-hosted-ui'))===true){
                    console.log("Logica para refrescar token login social")
                    auth_information = await refreshTokenSocial();   
                }else{
                    auth_information = await refreshSession();
                }
            
                closeRequest();
            } catch (error) {
                closeRequest();
            }
            const access_token = getToken();
            /*if(access_token==="undefined"){
                originalRequest.headers.Authorization = "Bearer " + auth_information?.data
            }else{
                originalRequest.headers.Authorization = "Bearer " + access_token
            }*/
            originalRequest.headers.Authorization = "Bearer " + access_token
            let redirectCall: any
            try {
                redirectCall = await axiosApiInstance(originalRequest);
                closeRequest();
            } catch (error) {
                closeRequest();
            }
            closeRequest();
            return redirectCall;
        } else {
            closeRequest();
            return Promise.reject(error);
        }

    })
}